import React, { useEffect, useState } from "react";
import {
  Input,
  Select,
  message,
  Form,
  Row,
  Col,
  Card,
  Typography,
  Icon,
  Avatar,
  Empty,
} from "antd";
import { platformApi } from "../../../../../../api";
import placeholder from "../../../../../../assets/vehicle-placeholder.jpg";
import VehicleName from "../../../../../VehicleName";

const { Option } = Select;
const { Search } = Input;
const { Item } = Form;
const { Text } = Typography;

const ImageForm = ({
  open,
  validityRef,
  form,
  data,
  selectedVehicles,
  manufacturers,
  onSelect,
}) => {
  // const [manufacturers, setManufacturers] = useState([]);
  const [models, setModels] = useState([]);
  const [initialModels, setInitialModels] = useState([]);
  const [selected, setSelected] = useState({});
  const [manufactId, setManufactId] = useState(null);

  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;

  const vehicleType = [
    {
      id: "ALL",
      name: "All Category",
    },
    {
      id: "SCOOTER",
      name: "Scooter",
    },
    {
      id: "MOTORCYCLE",
      name: "Motorcycle",
    },
  ];

  useEffect(() => {
    console.log(selected);
    if (selected?.price) onSelect(selected.price);
  }, [selected]);

  useEffect(() => {
    validityRef.current = () => {
      return validateFields();
    };
    return () => {
      validityRef.current = null;
    };
  });

  useEffect(() => {
    const Data = data || {};
    if (open) {
      platformApi
        .get("/api/manufacturer")
        .then((result) => {
          const { data } = result;
          if (data.code === 200) {
            const { response } = data;
            if (response && response.code === 200) {
              const firstmanuf = response?.data?.[0];
              if (!firstmanuf) {
                console.warn("No manufacturers returned from API");
                return;
              }
              setManufactId(firstmanuf.id);
              console.log("manufact id: ", firstmanuf.id);
              //setManufacturers(response.data);
              if (!Data.vehicleDetail) {
                setFieldsValue({
                  manufacturer: firstmanuf.id,
                  vehicleCategory: "ALL",
                });
                handleManufacturerChange(firstmanuf.id);
              }
            }
          }
        })
        .catch((error) => {
          message.error("Unable to fetch Manufacturers", 2);
          console.error("Error on Image Form : ", error);
        });
      if (Data.vehicleDetail) {
        setFieldsValue({
          manufacturer: Data.vehicleDetail.model.manufacturer.id,
          vehicleCategory: "ALL",
        });
        handleManufacturerChange(Data.vehicleDetail.model.manufacturer.id);
        setSelected(Data.vehicleDetail);
      }
    } else {
      form.resetFields();
      setModels([]);
      setSelected({});
      // setManufacturers([]);
    }
  }, [open]);

 const validateFields = () => {
  let isValid = false;
  
  form.validateFields((validationError) => {
    // Check if form validation passed AND a vehicle is selected
    if (validationError === null && selected && selected.model && selected.price) {
      isValid = true;
      data.vehicleDetail = selected;
      data.insuranceType = null;
      data.price = selected.price;
    } else {
      // Show error message if no vehicle selected
      if (!selected || !selected.model || !selected.price) {
        message.error("Please select a vehicle before proceeding");
      }
    }
  });
  
  return isValid;
};

  const handleVehicleCategory = (id) => {
    let tmpCategory = [];
    if (id === "ALL") tmpCategory = initialModels;
    else tmpCategory = initialModels.filter((model) => model.category === id);
    setModels(tmpCategory);
  };

  const handleManufacturerChange = (id) => {
    platformApi
      .get(`api/vehicleMaster/man/${id}`)
      .then((result) => {
        const { data } = result;
        if (data.code === 200) {
          const { response } = data;
          if (response.code === 200) {
            const models = response.data.filter(
              (model) => model.vehicleStatus === "AVAILABLE" && model.price[0]
            );
            let filteredModels = [];
            models.map((eachModel) => {
              let flag = true;
              selectedVehicles.map((eachSelected) => {
                if (eachModel.id === eachSelected.vehicleDetail.id) {
                  flag = false;
                }
              });
              if (flag) {
                filteredModels.push(eachModel);
              }
            });
            setModels(filteredModels);
            setFieldsValue({ vehicleCategory: "ALL" });
            setInitialModels(filteredModels);
          }
        }
      })
      .catch((error) => {
        message.error("Unable to fetch Manufacturers", 2);
        console.error("Error on Image Form : ", error);
      });
  };
  const SearchVehicle = (searchString) => {
    const searchTerm = (searchString || "").toLowerCase().trim();

    let filteredResults = [];

    if (searchTerm === "") {
      filteredResults = initialModels;
    } else {
      filteredResults = initialModels.filter((model) => {
        const modelCode = (model.modelCode || "").toLowerCase();
        const modelName = (model.modelName || "").toLowerCase();
        const manufacturerName = (model.manufacturer?.name || "").toLowerCase();
        const fullName = `${modelCode} ${modelName}`.toLowerCase();

        return (
          modelCode.includes(searchTerm) ||
          modelName.includes(searchTerm) ||
          manufacturerName.includes(searchTerm) ||
          fullName.includes(searchTerm)
        );
      });
    }

    let availableModels = [];
    filteredResults.forEach((model) => {
      let isSelected = false;
      selectedVehicles.forEach((selected) => {
        if (model.id === selected.vehicleDetail.id) {
          isSelected = true;
        }
      });
      if (!isSelected) {
        availableModels.push(model);
      }
    });

    setModels(availableModels);
    setFieldsValue({ vehicleCategory: "ALL" });
  };

  // New function to fetch all vehicles
  const fetchAllVehicles = () => {
    if (!manufacturers[0]?.id) return;

    platformApi
      .get(`api/vehicleMaster/man/${manufacturers[0].id}`)
      .then((result) => {
        const { data } = result;
        if (data.code === 200) {
          const { response } = data;
          if (response.code === 200) {
            const models = response.data.filter(
              (model) => model.vehicleStatus === "AVAILABLE" && model.price && model.price.length > 0
            );
            let filteredModels = [];
            models.map((eachModel) => {
              let flag = true;
              selectedVehicles.map((eachSelected) => {
                if (eachModel.id === eachSelected.vehicleDetail.id) {
                  flag = false;
                }
              });
              if (flag) {
                filteredModels.push(eachModel);
              }
            });
            setModels(filteredModels);
            setInitialModels(filteredModels);
          }
        }
      })
      .catch((error) => {
        message.error("Unable to fetch Manufacturers", 2);
        console.error("Error on Image Form : ", error);
      });
  };
  return (
    <Form>
      <Row type="flex" justify="space-between">
        <Col xs={24} sm={12} md={6}>
          <Item>
            {getFieldDecorator("manufacturer", {
              rules: [{ required: true, message: "Select a manufacturer" }],
            })(
              <Select
                placeholder="Manufacturer"
                onChange={handleManufacturerChange}
              >
                {manufacturers.map((manufacturer) => (
                  <Option key={manufacturer.id} value={manufacturer.id}>
                    {manufacturer.name}
                  </Option>
                ))}
              </Select>
            )}
          </Item>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Item>
            {getFieldDecorator("vehicleCategory", {
              rules: [{ required: true, message: "Select a manufacturer" }],
            })(
              <Select
                showAction={["click", "focus"]}
                placeholder="Vehicle Category"
                onChange={handleVehicleCategory}
                defaultValue="ALL"
              >
                {vehicleType.map((type) => (
                  <Option key={type.id} value={type.id}>
                    {type.name}
                  </Option>
                ))}
              </Select>
            )}
          </Item>
        </Col>

        <Col xs={24} sm={12} md={6}>
          <Item>
            <Search
              style={{ width: "100%" }}
              placeholder="Search by model code, name, or manufacturer"
              onChange={(e) => SearchVehicle(e.target.value)}
              allowClear
              enterButton={<Icon type="search" />}
            />
          </Item>
        </Col>
      </Row>
      <Row type="flex">
        <Item style={{ width: "100%" }}>
          <div
            className="vehicle-select-grid"
            style={{ height: 335, width: "100%", overflowY: "auto" }}
          >
            {!models?.length ? (
              <Empty description="No vehicles available" />
            ) : (
              <Row gutter={[12, 12]} type="flex">
                {models.flatMap((model) => {
                  const prices =
                    model.price && model.price.length > 0
                      ? model.price
                      : [null];
                  return prices.map((priceData, index) => {
                    const isActive =
                      priceData &&
                      selected?.model?.id === model.id &&
                      selected?.price?.id === priceData.id;
                    const coverSrc =
                      priceData?.colors?.[0]?.imageDetails?.[0]?.url ||
                      placeholder;
                    return (
                      <Col
                        xs={24}
                        sm={12}
                        md={8}
                        key={`${model.id}-${priceData?.id || index}`}
                      >
                        <Card
                          className="vehicle-select-card"
                          style={{ width: "100%" }}
                          onClick={() =>
                            priceData &&
                            setSelected({ model, price: priceData })
                          }
                          size="small"
                          hoverable={!!priceData}
                          cover={
                            <div className="vehicle-select-card__cover">
                              <img
                                alt={model.modelName}
                                src={coverSrc}
                                onError={(event) => {
                                  event.target.src = placeholder;
                                }}
                              />
                            </div>
                          }
                        >
                          <div className="vehicle-select-card-meta">
                            <Avatar
                              className="vehicle-select-card-meta__tick"
                              style={{
                                backgroundColor: isActive
                                  ? "#52c41a"
                                  : "lightGrey",
                              }}
                              icon={<Icon type="check" />}
                              size="small"
                            />
                            <Text
                              strong
                              className="vehicle-select-card-meta__name"
                            >
                              <VehicleName value={model} />
                            </Text>
                          </div>
                        </Card>
                      </Col>
                    );
                  });
                })}
              </Row>
            )}
          </div>
        </Item>
      </Row>
    </Form>
  );
};

const ImagesForm = Form.create()(ImageForm);

export default ImagesForm;
